<template>
  <div class="help-center-page">
    <!-- Header -->
    <a-layout-header class="header">
      <div class="header-content">
        <div class="logo-container" @click="$router.push('/')">
          <span class="logo-icon">S</span>
          <div class="logo-text">xxxxproxy</div>
        </div>
        <a-menu
          theme="light"
          mode="horizontal"
          :default-selected-keys="['3']"
          class="nav-menu"
        >
          <a-menu-item key="1"><router-link to="/">{{ $t('menu.home') }}</router-link></a-menu-item>
          <a-menu-item key="2"><router-link to="/dynamic-residential-proxy">{{ $t('menu.dynamicProxy') }}</router-link></a-menu-item>
          <a-menu-item key="static"><router-link to="/static-residential-proxy">{{ $t('menu.staticProxy') }}</router-link></a-menu-item>
          <a-menu-item key="3"><router-link to="/help-center">{{ $t('menu.helpCenter') }}</router-link></a-menu-item>
        </a-menu>
        <div class="auth-buttons">
          <template v-if="!isLoggedIn">
            <a-button type="link" class="login-btn" @click="$router.push('/login')">{{ $t('menu.login') }}</a-button>
            <a-button type="primary" class="register-btn" @click="$router.push('/register')">{{ $t('menu.register') }}</a-button>
          </template>
          <template v-else>
            <div class="user-profile-wrapper">
              <a-dropdown :trigger="['hover']" placement="bottomRight" :getPopupContainer="triggerNode => triggerNode.parentNode">
                <div class="user-profile-dropdown" @click="$router.push('/dashboard/auth')">
                  <a-avatar icon="user" class="avatar" />
                  <span class="username">{{ username }}</span>
                  <a-icon type="down" />
                </div>
                <a-menu slot="overlay" class="user-dropdown-menu">
                  <a-menu-item key="dashboard" @click="$router.push('/dashboard/auth')">
                    <a-icon type="dashboard" /> {{ $t('menu.dashboard') }}
                  </a-menu-item>
                  <a-menu-divider />
                  <a-menu-item key="logout" @click="handleLogout" class="logout-item">
                    <a-icon type="logout" /> {{ $t('menu.logout') }}
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </div>
          </template>
          <a-icon type="menu" class="mobile-menu-btn" @click="showMobileMenu = true" />
        </div>
      </div>
    </a-layout-header>

    <!-- Mobile Menu Drawer -->
    <a-drawer
      placement="right"
      :visible="showMobileMenu"
      @close="showMobileMenu = false"
      :closable="false"
      width="280"
      wrapClassName="mobile-menu-drawer"
    >
      <div class="drawer-content">
        <div class="drawer-header">
          <div class="drawer-brand">
            <span class="logo-icon">S</span>
            <span class="logo-text">xxxxproxy</span>
          </div>
          <div class="close-btn" @click="showMobileMenu = false">
            <a-icon type="close" />
          </div>
        </div>
        
        <div class="drawer-menu">
          <router-link to="/" class="menu-link" exact-active-class="active">
            <a-icon type="home" /> {{ $t('menu.home') }}
          </router-link>
          <router-link to="/dynamic-residential-proxy" class="menu-link" active-class="active">
            <a-icon type="thunderbolt" /> {{ $t('menu.dynamicProxy') }}
          </router-link>
          <router-link to="/static-residential-proxy" class="menu-link" active-class="active">
            <a-icon type="cloud-server" /> {{ $t('menu.staticProxy') }}
          </router-link>
          <router-link to="/help-center" class="menu-link" active-class="active">
            <a-icon type="question-circle" /> {{ $t('menu.helpCenter') }}
          </router-link>
        </div>

        <div class="drawer-auth">
          <template v-if="!isLoggedIn">
            <a-button block size="large" class="drawer-login-btn" @click="$router.push('/login')">{{ $t('menu.login') }}</a-button>
            <a-button block type="primary" size="large" class="drawer-register-btn" @click="$router.push('/register')">{{ $t('register.registerBtn') }}</a-button>
          </template>
          <template v-else>
            <div class="drawer-user-info">
              <a-avatar size="large" icon="user" class="avatar" />
              <div class="user-details">
                <span class="username">{{ username }}</span>
                <span class="status">在线</span>
              </div>
            </div>
            <a-button block size="large" class="drawer-dashboard-btn" @click="$router.push('/dashboard/auth')">
              <a-icon type="dashboard" /> {{ $t('menu.dashboard') }}
            </a-button>
            <a-button block size="large" type="danger" ghost class="drawer-logout-btn" @click="handleLogout">
              <a-icon type="logout" /> {{ $t('menu.logout') }}
            </a-button>
          </template>
        </div>
      </div>
    </a-drawer>

    <!-- Help Hero -->
    <div class="help-hero">
      <h1>{{ $t('help.hero.title') }}</h1>
      <p>{{ $t('help.hero.subtitle') }}</p>
    </div>

    <!-- FAQ Section -->
    <div class="faq-section">
      <div class="content-wrapper">
        <div class="faq-tabs-container">
          <a-tabs default-active-key="1" type="card" :tabBarGutter="10">
            <a-tab-pane v-for="category in faqCategories" :key="category.key" :tab="category.name">
              <a-collapse accordion :bordered="false" class="faq-collapse">
                <a-collapse-panel v-for="(item, index) in category.items" :key="index" :header="item.q">
                  <p v-html="item.a"></p>
                </a-collapse-panel>
              </a-collapse>
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
    </div>

    <!-- Contact Section -->
    <div class="contact-section">
      <h2>{{ $t('help.contact.title') }}</h2>
      <p>{{ $t('help.contact.desc') }}</p>
      <div class="contact-options">
        <a-button type="primary" size="large" icon="mail" @click="handleContactClick">{{ $t('help.contact.contactUs') }}</a-button>
        <!-- <a-button size="large" icon="message">在线咨询</a-button> -->
      </div>
    </div>

    <!-- Footer -->
    <a-layout-footer class="footer">
      <div class="footer-content">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24" :xs="24">
            <div class="footer-logo">xxxxproxy</div>
            <p>{{ $t('home.footer.desc') }}</p>
          </a-col>
          <a-col :md="16" :sm="24" :xs="24">
            <a-row :gutter="24">
              <a-col :span="8">
                <h4>{{ $t('home.footer.products') }}</h4>
                <ul>
                  <li><router-link to="/dynamic-residential-proxy">{{ $t('menu.dynamicProxy') }}</router-link></li>
                  <li><router-link to="/static-residential-proxy">{{ $t('menu.staticProxy') }}</router-link></li>
                </ul>
              </a-col>
              <a-col :span="8">
                <h4>{{ $t('home.footer.support') }}</h4>
                <p><router-link to="/help-center">{{ $t('menu.helpCenter') }}</router-link></p>
              </a-col>
              <a-col :span="8">
                <h4>{{ $t('home.footer.contact') }}</h4>
                <p>Email: zongtaiyida@gmail.com</p>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
        <div class="copyright">
          {{ $t('home.footer.copyright', { year: new Date().getFullYear() }) }}
        </div>
      </div>
    </a-layout-footer>

    <!-- Back Top -->
    <a-back-top :visibilityHeight="300">
      <div class="back-to-top-btn">
        <a-icon type="arrow-up" />
      </div>
    </a-back-top>
  </div>
</template>

<script>
export default {
  name: 'HelpCenter',
  data() {
    return {
      isLoggedIn: false,
      username: '',
      showMobileMenu: false
    };
  },
  computed: {
    faqCategories() {
      return [
        {
          name: this.$t('help.tabs.intro'),
          key: '1',
          items: [
            { q: this.$t('help.faq.q1'), a: this.$t('help.faq.a1') },
            { q: this.$t('help.faq.q2'), a: this.$t('help.faq.a2') },
            { q: this.$t('help.faq.q3'), a: this.$t('help.faq.a3') },
            { q: this.$t('help.faq.q4'), a: this.$t('help.faq.a4') },
            { q: this.$t('help.faq.q5'), a: this.$t('help.faq.a5') },
            { q: this.$t('help.faq.q6'), a: this.$t('help.faq.a6') },
            { q: this.$t('help.faq.q7'), a: this.$t('help.faq.a7') },
            { q: this.$t('help.faq.q8'), a: this.$t('help.faq.a8') },
            { q: this.$t('help.faq.q9'), a: this.$t('help.faq.a9') },
            { q: this.$t('help.faq.q10'), a: this.$t('help.faq.a10') },
            { q: this.$t('help.faq.q11'), a: this.$t('help.faq.a11') }
          ]
        },
        {
          name: this.$t('help.tabs.pricing'),
          key: '2',
          items: [
            { q: this.$t('help.faq.q12'), a: this.$t('help.faq.a12') },
            { q: this.$t('help.faq.q13'), a: this.$t('help.faq.a13') },
            { q: this.$t('help.faq.q14'), a: this.$t('help.faq.a14') },
            { q: this.$t('help.faq.q15'), a: this.$t('help.faq.a15') },
            { q: this.$t('help.faq.q16'), a: this.$t('help.faq.a16') },
            { q: this.$t('help.faq.q17'), a: this.$t('help.faq.a17') },
            { q: this.$t('help.faq.q18'), a: this.$t('help.faq.a18') },
            { q: this.$t('help.faq.q19'), a: this.$t('help.faq.a19') },
            { q: this.$t('help.faq.q20'), a: this.$t('help.faq.a20') },
            { q: this.$t('help.faq.q21'), a: this.$t('help.faq.a21') },
            { q: this.$t('help.faq.q22'), a: this.$t('help.faq.a22') },
            { q: this.$t('help.faq.q23'), a: this.$t('help.faq.a23') },
            { q: this.$t('help.faq.q24'), a: this.$t('help.faq.a24') }
          ]
        },
        {
          name: this.$t('help.tabs.account'),
          key: '3',
          items: [
            { q: this.$t('help.faq.q25'), a: this.$t('help.faq.a25') },
            { q: this.$t('help.faq.q26'), a: this.$t('help.faq.a26') },
            { q: this.$t('help.faq.q27'), a: this.$t('help.faq.a27') },
            { q: this.$t('help.faq.q28'), a: this.$t('help.faq.a28') }
          ]
        },
        {
          name: this.$t('help.tabs.troubleshoot'),
          key: '4',
          items: [
            { q: this.$t('help.faq.q29'), a: this.$t('help.faq.a29') },
            { q: this.$t('help.faq.q30'), a: this.$t('help.faq.a30') }
          ]
        }
      ];
    }
  },
  mounted() {
    this.checkLoginStatus();
    this.initScrollReveal();
  },
  methods: {
    handleContactClick() {
      window.location.href = 'mailto:zongtaiyida@gmail.com';
    },
    checkLoginStatus() {
      const token = localStorage.getItem('Token');
      const username = localStorage.getItem('userName');
      if (token && username) {
        this.isLoggedIn = true;
        this.username = username;
      }
    },
    handleLogout() {
      localStorage.clear();
      this.isLoggedIn = false;
      this.username = '';
      this.$message.success('退出登录成功');
      this.$router.push('/login');
    },
    initScrollReveal() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });

      setTimeout(() => {
        const animatedElements = document.querySelectorAll('.faq-section, .contact-section');
        animatedElements.forEach(el => {
          el.classList.add('scroll-reveal');
          observer.observe(el);
        });
      }, 100);
    }
  }
};
</script>

<style lang="less">
.user-dropdown-menu {
  padding: 8px;
  border-radius: 12px;
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.1), 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f7ff;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  min-width: 160px;
  
  .ant-dropdown-menu-item {
    border-radius: 8px;
    padding: 10px 16px;
    margin-bottom: 4px;
    font-weight: 500;
    color: #475569;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    
    .anticon {
      margin-right: 12px;
      font-size: 16px;
      color: #94a3b8;
      transition: all 0.2s;
    }
    
    &:last-child {
      margin-bottom: 0;
    }
    
    &:hover {
      background: #eff6ff;
      color: #1890ff;
      transform: translateX(2px);
      
      .anticon {
        color: #1890ff;
      }
    }
  }

  .ant-dropdown-menu-item-divider {
    background-color: #f1f5f9;
    margin: 6px 0;
  }
  
  .logout-item {
    &:hover {
      background: #fff1f2;
      color: #ef4444;
      
      .anticon {
        color: #ef4444;
      }
    }
  }
}
</style>

<style scoped lang="less">
// 变量定义
@primary-color: #1890ff;
@secondary-color: #69c0ff;
@dark-bg: #0A192F;
@text-main: #1e293b;
@text-light: #64748b;

.help-center-page {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  background: #f8fafc;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 40px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.scroll-reveal {
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s ease-out;
}

.scroll-reveal.is-visible {
  opacity: 1;
  transform: translateY(0);
}

/* Header Styles */
.header {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  box-shadow: 0 1px 0 rgba(0,0,0,0.05);
  padding: 0;
  height: 72px;
  line-height: 72px;
  position: sticky;
  top: 0;
  z-index: 1000;
}
.header-content {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}
.logo-container {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}
.logo-icon {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, @primary-color, @secondary-color);
  color: #fff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 20px;
}
.logo-text {
  font-size: 22px;
  font-weight: 800;
  color: @text-main;
  letter-spacing: -0.5px;
}
.nav-menu {
  flex: 1;
  border-bottom: none;
  line-height: 70px;
  background: transparent;
  display: flex;
  justify-content: center;
}
.nav-menu .ant-menu-item {
  font-size: 15px;
  font-weight: 500;
  margin: 0 16px;
  top: 0;
}
.nav-menu .ant-menu-item a {
  color: @text-main;
}
.nav-menu .ant-menu-item a:hover {
  color: @primary-color;
}
.nav-menu .ant-menu-item-selected {
  border-bottom: 2px solid @primary-color;
}
.nav-menu .ant-menu-item-selected a {
  color: @primary-color;
}
.auth-buttons {
  display: flex;
  align-items: center;
  gap: 12px;
}
.auth-buttons .login-btn {
  color: @text-main;
  font-weight: 600;
  font-size: 15px;
}
.auth-buttons .login-btn:hover {
  color: @primary-color;
}
.auth-buttons .register-btn {
  height: 40px;
  padding: 0 24px;
  font-size: 15px;
  border-radius: 20px;
  font-weight: 600;
  background: @text-main;
  border-color: @text-main;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}
.auth-buttons .register-btn:hover {
  background: @primary-color;
  border-color: @primary-color;
}

.auth-buttons .user-profile-dropdown {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 8px 4px 4px;
  height: 40px;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  line-height: 1.5;
  
  &:hover {
    background: rgba(0, 0, 0, 0.04);
    
    .username {
      color: @primary-color;
    }
    
    .anticon-down {
      color: @primary-color;
      transform: rotate(180deg);
    }
  }
  
  .avatar {
    width: 30px;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    background: linear-gradient(135deg, @primary-color, @secondary-color);
    border: 1px solid #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.3s;
  }
  
  .username {
    font-weight: 600;
    color: @text-main;
    font-size: 14px;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: color 0.3s;
  }
  
  .anticon-down {
    font-size: 12px;
    color: #94a3b8;
    margin-right: 4px;
    transition: all 0.3s;
  }
}

.mobile-menu-btn {
  display: none;
  font-size: 24px;
  color: #333;
  margin-left: 15px;
  cursor: pointer;
}

/* Help Hero */
.help-hero {
  background: @dark-bg;
  background-image: radial-gradient(circle at 50% 50%, #1A237E 0%, @dark-bg 100%);
  color: #fff;
  text-align: center;
  padding: 100px 24px;
}
.help-hero h1 {
  color: #fff;
  font-size: 48px;
  font-weight: 800;
  margin-bottom: 16px;
  animation: fadeInUp 0.8s ease-out;
}
.help-hero p {
  font-size: 20px;
  color: rgba(255,255,255,0.8);
  margin-bottom: 0;
  animation: fadeInUp 0.8s ease-out 0.2s backwards;
}

/* FAQ Section */
.faq-section {
  padding: 60px 24px;
}
.content-wrapper {
  max-width: 1000px;
  margin: 0 auto;
}
.faq-tabs-container {
  background: transparent;
}
.faq-tabs-container /deep/ .ant-tabs-bar {
  border-bottom: none;
  margin-bottom: 32px;
  text-align: center;
}
.faq-tabs-container /deep/ .ant-tabs-nav {
  display: inline-block;
  float: none;
}
.faq-tabs-container /deep/ .ant-tabs-tab {
  background: #fff;
  border: 1px solid #f1f5f9;
  border-radius: 20px;
  margin-right: 12px !important;
  font-size: 16px;
  padding: 8px 30px;
  height: auto;
  transition: all 0.3s;
  color: @text-main;
}
.faq-tabs-container /deep/ .ant-tabs-tab-active {
  background: @primary-color;
  color: #fff;
  border-color: @primary-color;
  box-shadow: 0 4px 12px rgba(61, 90, 254, 0.3);
}
.faq-collapse {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0,0,0,0.05);
  text-align: left;
  border: none;
}
.faq-collapse .ant-collapse-item {
  border-bottom: 1px solid #f1f5f9;
}
.faq-collapse .ant-collapse-item:last-child {
  border-bottom: none;
}
.faq-collapse .ant-collapse-header {
  font-size: 16px;
  font-weight: 600;
  color: @text-main;
  padding: 20px 24px !important;
}
.faq-collapse .ant-collapse-content-box {
  padding: 0 24px 24px !important;
  color: @text-light;
  line-height: 1.8;
}

/* Contact */
.contact-section {
  text-align: center;
  padding: 80px 24px;
  background: #fff;
}
.contact-section h2 {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 16px;
  color: @text-main;
}
.contact-section p {
  color: @text-light;
  font-size: 18px;
  margin-bottom: 40px;
}
.contact-options button {
  margin: 0 12px;
  height: 48px;
  border-radius: 24px;
  font-size: 16px;
}

/* Footer */
.footer {
  background: #fff;
  padding: 80px 0 40px;
  border-top: 1px solid #f1f5f9;
  margin-top: auto;
}
.footer-content {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
}
.footer-logo {
  font-size: 24px;
  font-weight: 800;
  color: @text-main;
  margin-bottom: 16px;
  letter-spacing: -0.5px;
}
.footer h4 {
  color: @text-main;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 24px;
}
.footer p {
  margin-bottom: 12px;
  color: @text-light;
}
.footer a {
  color: @text-light;
  transition: color 0.3s;
}
.footer a:hover {
  color: @primary-color;
}
.copyright {
  border-top: 1px solid #f1f5f9;
  margin-top: 60px;
  padding-top: 30px;
  text-align: center;
  color: #94a3b8;
  font-size: 14px;
}

@media (max-width: 768px) {
  /* Header */
  .header {
    height: 60px;
    line-height: 60px;
    padding: 0 10px;
  }
  .header-content {
    padding: 0 10px;
  }
  .logo-container {
    margin-right: 10px;
  }
  .logo-text {
    font-size: 18px;
  }
  .logo-icon {
    width: 28px;
    height: 28px;
    font-size: 16px;
  }
  .nav-menu {
    display: none;
  }
  .auth-buttons .login-btn,
  .auth-buttons .register-btn {
    display: none;
  }
  .user-profile-wrapper {
    padding-bottom: 10px;
    margin-bottom: -10px;
  }
  
  .user-profile-dropdown {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 4px 8px 4px 4px;
    height: 40px;
    background: transparent;
    border: 1px solid transparent;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    line-height: 1.5;
    
    &:hover {
      background: rgba(0, 0, 0, 0.04);
      
      .username {
        color: @primary-color;
      }
      
      .anticon-down {
        color: @primary-color;
        transform: rotate(180deg);
      }
    }
    
    .avatar {
      width: 30px;
      height: 30px;
      line-height: 30px;
      font-size: 16px;
      background: linear-gradient(135deg, @primary-color, @secondary-color);
      border: 1px solid #fff;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      transition: all 0.3s;
    }
    
    .username {
      font-weight: 600;
      color: @text-main;
      font-size: 14px;
      max-width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      transition: color 0.3s;
    }
    
    .anticon-down {
      font-size: 12px;
      color: #94a3b8;
      margin-right: 4px;
      transition: all 0.3s;
    }
  }

  .mobile-menu-btn {
    display: block;
  }

  /* Mobile Menu Styles */
  /deep/ .mobile-menu-drawer .ant-drawer-body {
    padding: 0;
    height: 100%;
  }

  .drawer-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 24px;
    background: #fff;
  }

  .drawer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
    
    .drawer-brand {
      display: flex;
      align-items: center;
      gap: 12px;
      
      .logo-icon {
        width: 32px;
        height: 32px;
        background: linear-gradient(135deg, @primary-color, @secondary-color);
        border-radius: 8px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 800;
        font-size: 18px;
      }
      
      .logo-text {
        font-size: 20px;
        font-weight: 800;
        color: @text-main;
      }
    }
    
    .close-btn {
      font-size: 20px;
      color: @text-light;
      cursor: pointer;
      padding: 8px;
      border-radius: 50%;
      background: #f1f5f9;
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s;
      
      &:active {
        background: #e2e8f0;
        transform: scale(0.95);
      }
    }
  }

  .drawer-menu {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
    
    .menu-link {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 16px;
      border-radius: 12px;
      color: @text-main;
      font-size: 16px;
      font-weight: 600;
      transition: all 0.3s;
      background: #f8fafc;
      
      i {
        font-size: 18px;
        color: @text-light;
        transition: color 0.3s;
      }
      
      &.active, &:active {
        background: #eff6ff;
        color: @primary-color;
        
        i {
          color: @primary-color;
        }
      }
    }
  }

  .drawer-auth {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 24px;
    padding-top: 24px;
    border-top: 1px solid #f1f5f9;
    
    .drawer-user-info {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 12px;
      background: #f8fafc;
      border-radius: 12px;
      margin-bottom: 8px;
      
      .avatar {
        background: linear-gradient(135deg, @primary-color, @secondary-color);
        box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
      }
      
      .user-details {
        display: flex;
        flex-direction: column;
        
        .username {
          font-weight: 700;
          color: @text-main;
          font-size: 16px;
        }
        
        .status {
          font-size: 12px;
          color: #10b981;
          display: flex;
          align-items: center;
          gap: 4px;
          
          &::before {
            content: '';
            width: 6px;
            height: 6px;
            background: #10b981;
            border-radius: 50%;
            display: inline-block;
          }
        }
      }
    }
    
    .drawer-login-btn, .drawer-dashboard-btn {
      border-radius: 12px;
      height: 48px;
      font-weight: 600;
      font-size: 16px;
      border: 1px solid #e2e8f0;
      color: @text-main;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      
      &:active {
        background: #f1f5f9;
      }
    }
    
    .drawer-logout-btn {
      border-radius: 12px;
      height: 48px;
      font-weight: 600;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
    }
    
    .drawer-register-btn {
      border-radius: 12px;
      height: 48px;
      font-weight: 600;
      font-size: 16px;
      background: @text-main;
      border-color: @text-main;
      box-shadow: 0 4px 12px rgba(0,0,0,0.1);
      
      &:active {
        background: @primary-color;
        border-color: @primary-color;
        transform: scale(0.98);
      }
    }
  }

  .help-hero {
    padding: 80px 24px;
  }
  .help-hero h1 {
    font-size: 32px;
  }
  .help-hero p {
    font-size: 16px;
  }

  .faq-section {
    padding: 40px 16px;
  }
  
  .faq-tabs-container /deep/ .ant-tabs-nav-scroll {
    overflow-x: auto;
    white-space: nowrap;
  }
  .faq-tabs-container /deep/ .ant-tabs-tab {
    margin-right: 8px !important;
    padding: 6px 16px;
    font-size: 14px;
  }

  .contact-section {
    padding: 60px 24px;
  }
  .contact-options {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .contact-options button {
    margin: 0;
    width: 100%;
  }
  
  /* Footer */
  .footer {
    padding: 40px 0 20px;
    text-align: center;
  }
  .footer .ant-col-8,
  .footer .ant-col-16 {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
    display: block;
    text-align: center;
    margin-bottom: 30px;
  }
  .footer .ant-col-span-8 {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
    display: block;
    margin-bottom: 20px;
  }
}
</style>
